// The one "you are here" look for navigation lists: the main sidebar and
// the secondary rails (agents, Settings sections, todo lists, projects,
// the selected mail row). The selected surface plus a 3px accent bar at
// the row's left edge, drawn as a ::before so it never moves the row's
// content. The row needs `relative`; a list whose bar should sit further
// out (the sidebar puts it on its own edge) overrides `before:left-*`.

/** Selected row: surface and text. */
export const SELECTED_ROW = "bg-selected text-fg";

/** Selected row: the accent bar. */
export const SELECTED_BAR =
  "before:pointer-events-none before:absolute before:bottom-[6px] before:left-0 before:top-[6px] before:w-[3px] before:rounded-pill before:bg-accent-fg before:content-['']";
